import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Art } from './Art';
/**
 * An auction sheet with its boxes, handwritten lines and the car's panel map, and the grade
 * stamped on it in vermilion. 200 × 150.
 */ export function StampedSheet({ title, className }) {
    return /*#__PURE__*/ _jsxs(Art, {
        viewBox: "0 0 200 150",
        title: title,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                className: "fsh",
                d: "M40 22h128l-2 120H38Z",
                transform: "translate(5 5)"
            }),
            /*#__PURE__*/ _jsxs("g", {
                transform: "rotate(-3 100 80)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        className: "fp",
                        d: "M38 18h128v122H38Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M46 28h112v26H46ZM46 41h112M74 28v26M102 28v26M130 28v26"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M50 35h16M78 35h14M106 35h18M50 48h12M80 48h16M108 48h10",
                        opacity: ".6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M70 64c-4 0-6 3-6 8v40c0 5 2 8 6 8h16c4 0 6-3 6-8V72c0-5-2-8-6-8Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M68 80h20M68 104h20",
                        opacity: ".7"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "sb thin",
                        d: "m60 70 4 4m0-4-4 4M94 98l4 4m0-4-4 4"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M104 66h48M104 76h40M104 86h46M104 96h30",
                        opacity: ".6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M46 128h40M110 128h46",
                        opacity: ".5"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("g", {
                transform: "rotate(-12 150 108)",
                children: [
                    /*#__PURE__*/ _jsx("circle", {
                        className: "sb",
                        cx: "150",
                        cy: "108",
                        r: "22",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ _jsx("circle", {
                        className: "sb thin",
                        cx: "150",
                        cy: "108",
                        r: "17.5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "sb",
                        d: "M152.6 96 142 113h15M152.6 96v22",
                        strokeWidth: "3.2"
                    })
                ]
            })
        ]
    });
}
